import React from "react";
import "./NavBar.css";

export default function NavBar(props) {
  return (
    <div className="nav__container">
      <h1 className="nav__title">Reserve a Table App</h1>
    </div>
  );
}
